import styled from 'styled-components';

import { theme } from '@/theme';

export const HeaderContainer = styled.div`
  position: relative;
  width: 100%;
  height: 220px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  ${theme.media.sm.up} {
    height: 320px;
  }
`;

export const BannerImage = styled.div<{ $backgroundImage: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${({ $backgroundImage }) => $backgroundImage});
  background-size: cover;
  background-position: center;
  filter: brightness(0.7);
`;

export const LogoContainer = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 170px;
    height: auto;
    filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.5));
  }

  ${theme.media.sm.up} {
    img {
      width: 200px;
    }
  }
`;
